import { easClient } from '../../common/client/apollo-client';
import { loader } from 'graphql.macro';
import { trackCustomHeapEvent } from '../../../utils/heap';
import { ErrorMessages } from '../../../utils/errorMessages';
import { ResetMultifactorAuthenticationResponse } from '../models/mfa-types';

const resetMfaMutation: any = loader('../../../graphql/mutations/reset-mfa.graphql');

class ResetMfaService {
  async resetMfa(): Promise<ResetMultifactorAuthenticationResponse> {
    try {
      const response = await easClient().mutate({
        mutation: resetMfaMutation,
        variables: {},
        fetchPolicy: 'network-only'
      });

      if (response?.errors?.[0]?.message) {
        throw new Error(response?.errors?.[0]?.message);
      }
      if (!response?.data?.resetMultifactorAuthentication.success) {
        throw new Error(ErrorMessages.SERVICE_UNAVAILABLE);
      }
      trackCustomHeapEvent('reset-mfa-services', { success: response?.data?.resetMultifactorAuthentication });
      return response?.data?.resetMultifactorAuthentication || {};
    } catch (error) {
      trackCustomHeapEvent('reset-mfa-services--error', { error });
      throw new Error(ErrorMessages.SERVICE_UNAVAILABLE);
    }
  }
}

export default ResetMfaService;
export const resetMfaService = new ResetMfaService();
